module.exports = __webpack_public_path__ + "static/media/linkedin.662eea78.svg";